import React from 'react'
import "./CloudManagersView.css"
import Isvg from 'react-inlinesvg';
import closeIcon from "images/icons/x-circle-icon.svg"
import editIcon from "images/icons/edit-pencil-icon.svg"
import gotoIcon from "images/icons/arrow-circle-icon.svg"
import className from "classnames";
import {openDialog} from "./../dialog/Dialog"
import { CircularProgress } from 'material-ui/Progress';
import moment from 'moment';
import { WarningIcon } from 'components/svg-icons/Icons';
import Tooltip from 'material-ui/Tooltip';
import { connect } from 'react-redux'
import * as actions from "./../../actions";
import RemoveOccmDialog from "./RemoveOccmDialog";
import UpdateOccmIps from "./UpdateOccmIps";
import ONTAPCloudLogo from "images/netapp-services/ontap-cloud.svg"

const isOlderThanThirtyMinutes = (date) => moment().subtract(30, 'minutes').valueOf() > date;

const serviceTracker = ({action}) =>
    (service) => window.ga('send', {
        hitType: 'event',
        eventCategory: 'LaunchPad',
        eventAction: action,
        eventLabel: service
    });

const track = serviceTracker({action: "ClickService"});
const trackIntent = serviceTracker({action: "IntentService"});

const CloudManagersView = props => {
    return (<div className="cloud-managers-view">
        <div className="component-container">
            <div className="component-header">
                <h3 className="left">Cloud Manager Systems</h3>
                <a href={window.__services.occmSetupService} className="button large occm-blue right" onContextMenu={() => {trackIntent("ontap-cloud")}} onClick={() => {track("ontap-cloud")}}>Create a New Cloud Manager</a>
            </div>
            {props.occms.status === actions.STATUS_SUCCESS && props.occms.data.occms.length > 0 && <div className="component-contents">
                {props.occms.data.occms.map(occm => (
                    <div key={occm.occm} className={className("occm-row", occm.status, {solitary: props.occms.data.occms.length === 1})}>
                        <a href={occm.primaryCallbackUri} className="occm-info" onContextMenu={() => {trackIntent("cloud-manager")}} onClick={() => {track("cloud-manager")}}>
                            <div className="logo">
                                <Isvg src={ONTAPCloudLogo} className={className({grey: occm.status !== "ready"})}/>
                            </div>
                            <div className="info">
                                <div className="title text-ellipsis">Name:</div>
                                <div className="text text-ellipsis">{occm.occmName}</div>
                            </div>
                            {occm.status === "ready" &&
                                <div className="info" style={{marginLeft: "20px", marginRight: "5px"}}>
                                    <div className="title text-ellipsis">Address:</div>
                                    <div className="text text-ellipsis">{occm.primaryCallbackUri}</div>
                                </div>
                            }
                            {occm.status === "ready" &&
                                <div className="goto">
                                    <Isvg src={gotoIcon} style={{position: "relative", top: 7}}/>
                                    Go to Cloud Manager
                                </div>
                            }
                            {
                                occm.status === "initializing" &&
                                (isOlderThanThirtyMinutes(occm.createDate) ?
                                        <Tooltip id="tooltip-icon" style={{cursor: "help"}} title="There may be a problem deploying this Cloud Manager system. Go to your cloud provider’s console to find the IP address for the system and then log in to complete the setup process. If you need help, contact us by clicking the chat icon in the lower right of your web browser." placement="bottom" classes={{root: "launching-text", tooltip: "hanging-tooltip"}}>
                                            <span>
                                                <WarningIcon style={{position: "relative", top: "8px", color: "#ffa100"}} />
                                                <span style={{color: "#ffa100"}}>Launch is hanging...</span>
                                            </span>
                                        </Tooltip>
                                        :
                                        <div className="launching-text">
                                            <CircularProgress style={{position: "relative", top: "3px"}} size={20} thickness={1.5} color="#898989" />
                                            <span>Launching Cloud Manager</span>
                                        </div>
                                )
                            }
                            {
                                occm.status === "failed" &&
                                <div className="failed-text">
                                    Cloud Manager failed to launch
                                </div>
                            }
                        </a>
                        <div className="occm-menu">
                            <div className="dots">
                                <div className="d1"></div>
                                <div className="d2"></div>
                                <div className="d3"></div>
                            </div>
                            <div className="menu-children">
                                <button disabled={occm.status !== "ready"} className="menu-child" onClick={(el) => openDialog(<UpdateOccmIps occm={occm} className="update-occm-uris-dialog"/>, el.target)}>
                                    <Isvg src={editIcon} style={{width: 13.5, height: 13.5, top: 2}}/> Edit URIs
                                </button>
                                <button className="menu-child" onClick={(el) => openDialog(<RemoveOccmDialog occm={occm} className="remove-occm-dialog"/>, el.target)}>
                                    <Isvg src={closeIcon} style={{width: 15, height: 15, top: 3}}/> Remove Listing
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>}
        </div>
    </div>
)};

const mapStateToProps = state => {
    return {
        occms: state.services.occms
    };
};

export default connect(mapStateToProps, {})(CloudManagersView)


// WEBPACK FOOTER //
// ./src/components/launch-pad/CloudManagersView.js